/** Открытие окна не доказывает загрузку матча. Ответ расширения — отдельный этап. */
import { create } from 'zustand';
import type { DriveNote } from '../confirm/drive';

export type OpenState = 'opening' | 'sent' | 'blocked' | 'no-link' | 'update' | 'desk-error';
export interface BookAttempt { at: number; url: string | null; state: OpenState; detail?: string }
export const openingKey = (id: string, venue: string): string => JSON.stringify([id, venue]);
export const useBookOpening = create<{
  by: Record<string, BookAttempt>;
  note: (id: string, venue: string, attempt: BookAttempt) => void;
}>((set) => ({
  by: {},
  note: (id, venue, attempt) => set(({ by }) => (by[openingKey(id, venue)]?.at ?? 0) > attempt.at ? { by } : ({
    by: { ...Object.fromEntries(Object.entries(by).filter(([key]) => key !== openingKey(id, venue)).slice(-63)),
      [openingKey(id, venue)]: attempt },
  })),
}));

export function openingText(attempt: BookAttempt | undefined, drive: DriveNote | undefined,
  now: number, expected: { odds: string; amount: string }): string | null {
  void drive;
  void now;
  void expected;
  if (!attempt) return null;
  if (attempt.state === 'no-link') return 'ссылки на БК нет — найдите событие на сайте конторы';
  if (attempt.state === 'blocked') return 'ссылка не открылась — разрешите всплывающие окна и повторите';
  if (attempt.state === 'update') return 'ссылка не открылась — обновите расширение FORQ';
  if (attempt.state === 'desk-error') return `ссылка не открылась в AdsPower${attempt.detail ? `: ${attempt.detail}` : ''}`;
  return null;
}
